export const CHAMPION_LABEL = 'Champion';
